export class ExpertOptionField {
    constructor(field) {
        this.field = field

        this.isValid = ExpertOptionField.checkIfValid(field)

        if (!this.isValid) {
            throw new Error(`Not a valid field: '${field}'!`)
        }
    }

    static checkIfValid(field) {
        field = field.trim()

        if (!field) {
            return false
        }

        return this.listOfValidFields.includes(field)

    }

    static listOfValidFields = [
        'title',
        'firstName',
        'lastName',
        'originalName',
        'city',
        'state',
        'country',
        'timezone',
        'industry',
        'language',
        'industryExperience',
        'expertIndustryExperience',
        'hourlyRate',
        'currentUsGovernmentEmployee',
        'workExperience',
        'phoneNumber',
        'email',
        'link',
        'source',
        'newsletterSubscribe',
        'sendSmsReminders'
    ]


    static Title = Object.freeze(new this('title'))
    static FirstName = Object.freeze(new this('firstName'))
    static LastName = Object.freeze(new this('lastName'))
    static OriginalName = Object.freeze(new this('originalName'))
    static City = Object.freeze(new this('city'))
    static State = Object.freeze(new this('state'))
    static Country = Object.freeze(new this('country'))
    static Timezone = Object.freeze(new this('timezone'))
    static Industry = Object.freeze(new this('industry'))
    static Language = Object.freeze(new this('language'))
    static IndustryExperience = Object.freeze(new this('industryExperience'))
    static ExpertIndustryExperience = Object.freeze(new this('expertIndustryExperience'))
    static HourlyRate = Object.freeze(new this('hourlyRate'))
    static CurrentUsGovernmentEmployee = Object.freeze(new this('currentUsGovernmentEmployee'))
    static WorkExperience = Object.freeze(new this('workExperience'))
    static PhoneNumber = Object.freeze(new this('phoneNumber'))
    static Email = Object.freeze(new this('email'))
    static Link = Object.freeze(new this('link'))
    static Source = Object.freeze(new this('source'))
    static NewsletterSubscribe = Object.freeze(new this('newsletterSubscribe'))
    static SendSmsReminders = Object.freeze(new this('sendSmsReminders'))

    static GetAllFields = () => {
        return [
            this.Title,
            this.FirstName,
            this.LastName,
            this.OriginalName,
            this.City,
            this.State,
            this.Country,
            this.Timezone,
            this.Industry,
            this.Language,
            this.IndustryExperience,
            this.ExpertIndustryExperience,
            this.HourlyRate,
            this.CurrentUsGovernmentEmployee,
            this.WorkExperience,
            this.PhoneNumber,
            this.Email,
            this.Link,
            this.Source,
            this.NewsletterSubscribe,
            this.SendSmsReminders
        ]
    }
}